import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export const Problem = () => {
  return <AnimatedSection className="bg-sepia/30 border-y border-ink/10 relative" data-id="element-127">
      <div className="absolute left-1/2 -top-3 -translate-x-1/2 bg-paper px-4 text-ink/40" data-id="element-128">
        <span className="text-2xl font-serif italic" data-id="element-129">§</span>
      </div>

      <div className="mb-10 text-center" data-id="element-130">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50" data-id="element-131">
          EL PROBLEMA REAL
        </span>
      </div>

      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-132">
        <h2 className="text-3xl md:text-4xl font-serif text-ink leading-tight" data-id="element-133">
          El problema no es que no trabajes lo suficiente.{' '}
          <br className="hidden md:block" data-id="element-134" />
          <span className="italic text-accent" data-id="element-135">
            El problema es que vendés tu tiempo en la moneda equivocada.
          </span>
        </h2>

        <div className="w-16 h-[1px] bg-ink/20 mx-auto" data-id="element-136"></div>

        <p className="text-lg font-sans text-ink/80 leading-relaxed text-left md:text-center" data-id="element-137">
          Pasás horas haciendo scroll en Instagram gratis, mientras podrías
          estar usando esos mismos chats para agendar citas de venta. Quizás
          intentaste trading y perdiste plata, o cursos de programación que
          nunca terminaste porque eran imposibles. Te frustraste porque buscabas
          "dinero fácil" o habilidades demasiado complejas que no pagan hoy
          mismo.
        </p>
      </div>
    </AnimatedSection>;
};